 // Helper function to check if a role is present
export const hasRole = (requiredRoles: string[],roles:string[]) => {
    return roles.some(role => requiredRoles.includes(role));
};